exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    flex: 1 1 auto;\r\n    background-color: #c6c6c6;\r\n    margin-bottom: 10px;\r\n    overflow: auto;\r\n}\r\n\r\nul {\r\n    display: flex;\r\n    flex-direction: column;\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\nli {\r\n    display: inline;\r\n    flex-grow: 1;\r\n    height: 80px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/fw/menu/submenu.component.css
// module id = 2134
// module chunks = 1